export default "__VITE_ASSET__98a0ea9b__"